import * as Yup from "yup";

const TRANSLATION_BASE_PATH = "_SELECT_ORGANIZATION._CHOOSE_AS_TEACHER._JOIN_ORGANIZATION";

export const formValidator = (translate: (key: string) => string) =>
	Yup.object({
		organizationCode: Yup.string().nullable().required(translate(`${TRANSLATION_BASE_PATH}._REQUIRED`))
	});
